import { render, staticRenderFns } from "./PageThanks.vue?vue&type=template&id=6987a23a&scoped=true"
import script from "./PageThanks.vue?vue&type=script&lang=js"
export * from "./PageThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987a23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6987a23a')) {
      api.createRecord('6987a23a', component.options)
    } else {
      api.reload('6987a23a', component.options)
    }
    module.hot.accept("./PageThanks.vue?vue&type=template&id=6987a23a&scoped=true", function () {
      api.rerender('6987a23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PageThanks.vue"
export default component.exports